import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'

import InfoBlock from '../components/InfoBlock'
import { formatMoney, formatPercentage } from '../../packages/utils/numberFormatters'

const compareBySizeAndName = (a, b) => {
    const aSize = a.amountInCash
    const bSize = b.amountInCash
    if (aSize > bSize) {
        return -1
    }
    if (aSize < bSize) {
        return 1
    }
    if (a.name < b.name) {
        return -1
    }
    if (a.name > b.name) {
        return 1
    }
    return 0
}

const INCOMPLETE_INFORMATION_TEXT =
    'Fullständig information angående deltagare och vilka belopp har ej kommunicerats av bolaget.'

function Investors({ issue }) {
    const { i18n } = useTranslation()
    const locale = i18n.language

    const investors = issue.investors.filter((investor) => !investor.isSeller)
    let content = null

    if (!issue.noInvestorsNamedChecked && investors.length > 0) {
        const totalInvestorsSize = investors.reduce((acc, row) => acc + row.amountInCash, 0) || null
        const totalInvestorsPercentage = investors.reduce((acc, row) => acc + row.amountInPercentage, 0) || null
        content = (
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Namn</TableCell>
                            <TableCell>Belopp ({issue.currency})</TableCell>
                            <TableCell>Andel</TableCell>
                            <TableCell>Leo</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {investors
                            .filter((investor) => !investor.isSeller)
                            .sort(compareBySizeAndName)
                            .map((investor) => {
                                return (
                                    <TableRow
                                        key={investor.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell>
                                            {investor.name === '?' ? (
                                                <Typography variant='body3'>Ej namngiven</Typography>
                                            ) : (
                                                <Link to={`/investors/${investor.investorId}`}>{investor.name}</Link>
                                            )}
                                        </TableCell>
                                        <TableCell component='td' scope='row'>
                                            {formatMoney(investor.amountInCash, {
                                                locale,
                                                decimals: 0,
                                            })}
                                        </TableCell>
                                        <TableCell component='td' scope='row'>
                                            {formatPercentage(investor.amountInPercentage, {
                                                locale,
                                                decimals: 0,
                                            })}
                                        </TableCell>
                                        <TableCell>{investor.leo ? 'Ja' : ''}</TableCell>
                                    </TableRow>
                                )
                            })}
                        <TableRow>
                            <TableCell>
                                <b>Summa</b>
                            </TableCell>
                            <TableCell>
                                <b>{formatMoney(totalInvestorsSize, { locale, decimals: 0 })}</b>
                            </TableCell>
                            <TableCell>
                                <b>
                                    {formatPercentage(totalInvestorsPercentage, {
                                        locale,
                                        decimals: 0,
                                    })}
                                </b>
                            </TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        {totalInvestorsPercentage < 99 && (
                            <TableRow>
                                <TableCell colSpan={4}>
                                    <i>{INCOMPLETE_INFORMATION_TEXT}</i>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    } else {
        content = (
            <span>
                <i>{INCOMPLETE_INFORMATION_TEXT}</i>
            </span>
        )
    }

    return (
        <InfoBlock title='Investerare' loadingElement={!content}>
            {content}
        </InfoBlock>
    )
}

export default Investors
